module.exports = __webpack_public_path__ + "static/willleineweber-52a6d372ef07a176449bc91e6ef9602e.jpg";